import React from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import {
  allowedLanguages,
  allowedFilterDataPropTypes,
  allowedColumnTextAligns,
  allowedTableColumnPropTypes,
  allowedTablePartProps
} from '../utils/allowedPropTypes';
import DataTableHeading from './_DataTableHeading';
import Pagination from './_Pagination';

const DataTableHead = ({ tableColumns, languageCode, paginationData: paginationProps = {} }) => {
  const { renderLocation } = paginationProps;

  return (
    <thead>
      {renderLocation === 'top' || renderLocation === 'both' ? <Pagination {...paginationProps} /> : null}

      <tr>
        {tableColumns.map(columnData => {
          const headingProps = {
            columnData,
            languageCode,
            key: uuidv4()
          };

          return <DataTableHeading {...headingProps} />;
        })}
      </tr>
    </thead>
  );
};

DataTableHead.propTypes = {
  ...allowedTablePartProps,
  languageCode: PropTypes.oneOf(allowedLanguages),
  tableColumns: PropTypes.arrayOf(
    PropTypes.shape({
      ...allowedTableColumnPropTypes,
      columnTitle: PropTypes.string.isRequired,
      columnTextAlign: PropTypes.oneOf(allowedColumnTextAligns),
      dataFilter: PropTypes.shape(allowedFilterDataPropTypes)
    })
  ).isRequired
};

export default DataTableHead;